module.exports = __webpack_public_path__ + "img/friend5.dd0ad245.png";